import { types as coreTypes } from '@sitebuilder/core';

export const componentThemes: coreTypes.ComponentThemes = {
    linkComponent: {
        fontFamily: 'OpenSans-Regular',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '24px',

        textColor: JSON.parse('"var(--color-text-link)"'),
        activeTextColor: JSON.parse('"var(--color-text-link)"'),
        activeBorderWidth: '0px 0px 1px 0px',
        activeBorderColor: JSON.parse('"var(--color-text-link)"'),
        activeBorderStyle: 'solid',
        textDecoration: 'none',
        hoverTextColor: JSON.parse('"var(--color-text-link)"'),
        visitedTextColor: JSON.parse('"var(--color-text-link)"'),
    },
    buttonComponent: {
        primaryBorderColor: JSON.parse('"var(--color-primary-border)"'),
        primaryBackgroundColor: JSON.parse('"var(--color-primary-main)"'),

        disabledBorderColor: JSON.parse('"var(--color-text-primary)"'),
        disabledBackgroundColor: JSON.parse('"var(--color-text-disabled)"'),
        deleteBorderColor: JSON.parse('"var(--color-error-border)"'),
        deleteBackGroundColor: JSON.parse('"var(--color-error-main)"'),
        okBorderColor: JSON.parse('"var(--color-primary-border)"'),
        okBackGroundColor: JSON.parse('"var(--color-primary-main)"'),

        borderWidth: '1px',
        borderStyle: 'solid',
        padding: '4px 8px 4px 8px',
        fontSize: '14px',
        fontFamily: 'OpenSans-Regular',
        lineHeight: '24px',
        fontWeight: 'normal',
        borderRadius: '4px',

        textColor: JSON.parse('"var(--color-text-primary)"'),
    },
    tableComponent: {
        tableWidth: '100%',
        thFontFamily: 'OpenSans-Regular',
        thFontSize: '14px',
        thFontWeight: '700',
        thLineHeight: '24px',
        thBorderWidth: '0px 0px 1px 0px',
        thBorderStyle: 'solid',
        thPadding: '8px',
        tdFontFamily: 'OpenSans-Regular',
        tdFontSize: '14px',
        tdFontWeight: '400',
        tdLineHeight: '24px',
        tdBorderWidth: '0px 0px 1px 0px',
        tdBorderStyle: 'solid',
        tdPadding: '8px',
        thTextColor: JSON.parse('"var(--default-text-color)"'),
        thBorderColor: JSON.parse('"var(--color-border-medium)"'),
        tdTextColor: JSON.parse('"var(--default-text-color)"'),
        tdBorderColor: JSON.parse('"var(--color-border-medium)"'),
        alternatedRowsBGColor: JSON.parse('"var(--color-primary-lightest)"'),
        rowGroupBackgroundColor: JSON.parse('"var(--color-primary-main)"'),
    },
    listComponent: {
        listPadding: '0px 0px 0px 0px',
        listItemPadding: '4px 0px 4px 0px',
        listItemFontFamily: 'OpenSans-Regular',
        listItemFontSize: '14px',
        listItemFontWeight: '400',
        listItemLineHeight: '24px',
        listItemBorderWidth: '0px 0px 1px 0px',
        listItemBorderStyle: 'solid',
        listKeyFontWeight: '700',
        listKeyFontFamily: 'OpenSans-Regular',
        listKeyFontSize: '14px',
        listValueFontWeight: '400',
        listValueFontFamily: 'OpenSans-Regular',
        listValueFontSize: '14px',
        listItemTextColor: JSON.parse('"var(--default-text-color)"'),
        listItemBorderColor: JSON.parse('"var(--color-border-medium)"'),
        listKeyTextColor: JSON.parse('"var(--default-text-color)"'),
        listValueTextColor: JSON.parse('"var(--default-text-color)"'),
        alternateListItemsBgColor: JSON.parse('"var(--color-primary-lightest)"'),
    },
    sectionComponent: {
        fontFamily: 'OpenSans-Regular',
        fontSize: '14px',
        fontWeight: 'normal',
        lineHeight: '',
        wordSpacing: '',
        textIndent: '',
        verticalAlignment: '',
        horizontalAlignment: '',
        padding: '0px 0px 0px 0px',
        margin: '0px 0px 0px 0px',
        color: JSON.parse('"var(--default-text-color)"'),
    },
    modalComponent: {
        fontFamily: 'OpenSans-Regular',
        fontSize: '14px',
        fontWeight: 'normal',
        padding: '0px 0px 0px 0px',
        margin: '1.75rem auto 1.75rem auto',
        maxWidth: '800px',
        modalContentDisplay: 'flex',
        modalContentFlexDirection: 'column',
        modalContentWidth: '100%',
        modalContentColor: 'var(--default-text-color)',
        modalContentBackgroundColor: 'var(--color-primary-main)',

        modalContentBorder: '1px solid rgba(0, 0, 0, 0.2)',
        modalContentBorderRadius: '0.3rem',
        modalHeaderDisplay: 'flex',
        modalHeaderAlignItems: 'center',
        modalHeaderJustifyContent: 'space-between',
        modalHeaderBorderBottom: '1px solid var(--color-grey-light)',
        modalHeaderBorderTopLeftRadius: 'calc(0.3rem - 1px)',
        modalHeaderBorderTopRightRadius: 'calc(0.3rem - 1px)',
        modalHeaderFontSize: '14px',
        modalHeaderFontWeight: 'normal',
        modalHeaderPadding: '1rem 1rem 1rem 1rem',
        modalHeaderMargin: '0px 0px 0px 0px',
        modalBodyFontSize: '14px',
        modalBodyFontWeight: 'normal',
        modalBodyPadding: '0px 0px 0px 0px',
        modalBodyMargin: '1rem 1rem 1rem 1rem',
    },
};
